import PositionService from 'src/modules/position/positionService';
import Errors from 'src/modules/shared/error/errors';
import { getHistory } from 'src/modules/store';

const prefix = 'POSITION_VIEW';

const positionViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({
        type: positionViewActions.FIND_STARTED,
      });

      const record = await PositionService.find(id);

      dispatch({
        type: positionViewActions.FIND_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: positionViewActions.FIND_ERROR,
      });

      getHistory().push('/position');
    }
  },
};

export default positionViewActions;
